import { Language } from '~/apiClient';
import { Locale } from '~i18n/i18nConfig';

export const localeToLanguage = (locale: Locale): Language => {
    const localeLanguageMap: Record<Locale, Language> = {
        [Locale.CS]: Language.cs,
        [Locale.DE]: Language.de,
        [Locale.EN]: Language.en,
        [Locale.ES]: Language.es,
        [Locale.FR]: Language.fr,
        [Locale.IT]: Language.it,
        [Locale.NL]: Language.nl,
        [Locale.PL]: Language.pl,
        [Locale.PT]: Language.pt,
        [Locale.RO]: Language.ro,
        [Locale.RU]: Language.ru,
    };

    return localeLanguageMap[locale];
};
